// Shared "thinking" state: the baton handoff animation, cropped tight so the
// label sits right under the artwork (the source GIF has a white canvas, so on
// light surfaces it blends in via multiply; on dark surfaces we sit it on a
// small cream plate so the artwork stays readable).
const SIZES = {
  sm: { box: "h-16 w-32", img: "w-32" },
  md: { box: "h-24 w-44", img: "w-44" },
  lg: { box: "h-32 sm:h-40 w-56 sm:w-72", img: "w-56 sm:w-72" },
};

export const RelayLoader = ({
  label = "Getting your race ready…",
  subLabel = null,
  size = "lg",
  tone = "light",
  className = "",
}) => {
  const s = SIZES[size] || SIZES.lg;
  const dark = tone === "dark";

  return (
    <div
      className={`flex flex-col items-center justify-center text-center ${className}`}
      data-testid="relay-loader"
    >
      <div
        className={`${s.box} overflow-hidden flex items-center justify-center ${dark ? "rounded-2xl" : ""}`}
        style={dark ? { background: "#FDFBF7" } : undefined}
      >
        <img
          src="/brand/relay-loader.gif"
          alt=""
          aria-hidden="true"
          className={`${s.img} max-w-none mix-blend-multiply`}
        />
      </div>
      {label && (
        <p
          className="text-sm"
          style={{ color: dark ? "#EDE9F7" : "var(--pr-ink2)" }}
          data-testid="relay-loader-label"
        >
          {label}
        </p>
      )}
      {subLabel && (
        <p
          className="text-xs mt-1"
          style={{ color: dark ? "#B8B3CE" : "var(--pr-muted)" }}
          data-testid="relay-loader-sublabel"
        >
          {subLabel}
        </p>
      )}
    </div>
  );
};

export default RelayLoader;
